export default __webpack_public_path__ + "static/media/spinner.222a80ed.gif";